import * as e from "react";
const l = (t) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...t
  },
  /* @__PURE__ */ e.createElement("g", { fill: "#738AAB", clipPath: "url(#search-outline_svg__clip0_6688_1103)" }, /* @__PURE__ */ e.createElement("path", { d: "M8 16.5a8 8 0 118-8 8.009 8.009 0 01-8 8zm0-14a6 6 0 106 6 6.006 6.006 0 00-6-6zM19 20.5a1 1 0 01-.707-.293l-4-4a1 1 0 011.414-1.414l4 4A1 1 0 0119 20.5z" })),
  /* @__PURE__ */ e.createElement("defs", null, /* @__PURE__ */ e.createElement("clipPath", { id: "search-outline_svg__clip0_6688_1103" }, /* @__PURE__ */ e.createElement("path", { fill: "#fff", transform: "translate(0 .5)", d: "M0 0h20v20H0z" })))
);
export {
  l as default
};
